import { render, staticRenderFns } from "./SchoolNews.vue?vue&type=template&id=489819c6&scoped=true&"
import script from "./SchoolNews.vue?vue&type=script&lang=js&"
export * from "./SchoolNews.vue?vue&type=script&lang=js&"
import style0 from "./SchoolNews.vue?vue&type=style&index=0&id=489819c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489819c6",
  null
  
)

export default component.exports